import { useState, useEffect } from 'react';
import { apiClient } from '../utils/apiClient';

export default function AuthImage({ uploadId, className, alt = '' }) {
    const [src, setSrc] = useState(null);

    useEffect(() => {
        if (!uploadId) return;
        let objectUrl = null;

        apiClient(
            `${process.env.REACT_APP_API_BASE_URL}/get_image.php?id=${uploadId}`,
            { method: 'GET' }
        )
            .then(res => res.blob())
            .then(blob => {
                objectUrl = URL.createObjectURL(blob);
                setSrc(objectUrl);
            })
            .catch(() => {});

        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [uploadId]);

    if (!src) return null;
    return <img src={src} className={className} alt={alt} />;
}
